webpackJsonp([0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var platform_browser_dynamic_1 = __webpack_require__(1);
	var core_1 = __webpack_require__(3);
	var app_module_1 = __webpack_require__(23);
	if (true) {
	    core_1.enableProdMode();
	}
	platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule);


/***/ },

/***/ 23:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var platform_browser_1 = __webpack_require__(21);
	var app_component_1 = __webpack_require__(24);
	var AppModule = (function () {
	    function AppModule() {
	    }
	    AppModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                platform_browser_1.BrowserModule
	            ],
	            declarations: [
	                app_component_1.AppComponent
	            ],
	            bootstrap: [app_component_1.AppComponent]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AppModule);
	    return AppModule;
	}());
	exports.AppModule = AppModule;


/***/ },

/***/ 24:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	__webpack_require__(25);
	var AppComponent = (function () {
	    function AppComponent() {
	    }
	    AppComponent = __decorate([
	        core_1.Component({
	            selector: 'my-app',
	            template: __webpack_require__(33),
	            styles: [__webpack_require__(34)]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AppComponent);
	    return AppComponent;
	}());
	exports.AppComponent = AppComponent;


/***/ },

/***/ 25:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 33:
/***/ function(module, exports) {

	module.exports = "<main>\n    <div id=\"nekland-logo\">\n        <h1>Nekland</h1>\n        <div id=\"circles\">\n            <div class=\"circle blue\"></div>\n            <div class=\"circle green\"></div>\n            <div class=\"circle orange\"></div>\n            <div class=\"circle violet\"></div>\n        </div>\n    </div>\n    <div id=\"content\">\n        <p>\n            <span class=\"b\" title=\"So much waiting for just that ? Yup!\">Hey!</span> I'm trying to make Nekland awesome.\n            This is a temporary page.\n        </p>\n        <p>\n            But you still can take a look at my <a href=\"http://cv.nekland.fr\">resume</a>.\n        </p>\n        <p>\n            Oh, and I'm also an open source enthusiast. So feel free to check my <a href=\"http://github.com/Nek-\">Github account</a>.\n        </p>\n    </div>\n</main>\n";

/***/ },

/***/ 34:
/***/ function(module, exports) {

	module.exports = "main {\n    display: block;\n}\n.circle {\n    border-radius: 27px;\n    height: 54px;\n    width: 54px;\n    margin-right: 2px;\n    display: inline-block;\n    opacity: 0;\n    animation-name: show;\n    animation-duration: 500ms;\n    animation-fill-mode: forwards;\n}\n#circles::last-child {\n    margin-right: 0;\n}\n\n.circle.blue {\n    background: #3498db;\n    animation-delay: 500ms;\n}\n.circle.green {\n    background: #2ecc71;\n    animation-delay: 1200ms;\n}\n.circle.orange {\n    background: #e67e22;\n    animation-delay: 1900ms;\n}\n.circle.violet {\n    background: #9b59b6;\n    animation-delay: 2600ms;\n}\n\n#nekland-logo {\n    animation-delay: 3300ms;\n    animation-fill-mode: forwards;\n    animation-duration: 500ms;\n    animation-name: title_top;\n}\n\n#content {\n    opacity: 0;\n    animation-name: show;\n    animation-duration: 500ms;\n    animation-fill-mode: forwards;\n    animation-delay: 4000ms;\n    margin-top: 120px;\n}\n\np {\n    margin: auto;\n    font-family: Ubuntu, \"Trebuchet MS\", Arial, sans-serif;\n    color: #888;\n    text-align: justify;\n    width: 241px;\n    margin-top: 20px;\n}\n\na {\n    text-decoration: none;\n    color: black;\n}\na:hover {\n    color: #888;\n}\n\n@keyframes show {\n    from {opacity: 0;}\n    to {opacity: 1;}\n}\n\n@keyframes title_top {\n    from {\n        margin-top: 300px;\n    }\n    to {\n        margin-top: 20px;\n    }\n}"

/***/ }

});


/** WEBPACK FOOTER **
 ** app.5ae82da3ec8390a5502c.js
 **/